
export default class EmailTemplateFormController {

	constructor (emailTemplate, EmailTemplate, $state) {
		this.EmailTemplate = EmailTemplate;
		this.$state = $state;

		this.emailTemplate = emailTemplate;
	}

	back () {
		this.$state.go('emailTemplatesPage');
	}

	submit () {
        this.EmailTemplate.update(
            this.emailTemplate.id,
            this.emailTemplate
        ).then(this.back.bind(this));
	}

}

EmailTemplateFormController.$inject = ['emailTemplate', 'EmailTemplate', '$state'];



// WEBPACK FOOTER //
// ./src/page/emailTemplateForm/emailTemplateForm.controller.js